export enum CurrencyNameEnum {
  Dolar = 'DOLAR',
  Peso = 'PESO',
  Euro = 'EURO'
}
